import React from "react";
import useReveal from "../hooks/useReveal";
import PageHero from "../components/PageHero";
import Contact from "../components/Contact";

export default function ContactPage() {
  useReveal();
  return (
    <>
      <PageHero eyebrow="Contact Us" title="Visit VIIMII" subtitle="Book your appointment, find us on the map, or say hello on WhatsApp." />
      <Contact />
    </>
  );
}
